import React from "react"
import { Card, CardContent, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next'; 

const MetricCard = ({ label, value }) => {
    const { t } = useTranslation();
    return (
        <Card className="mtska-metric-card">
            <CardContent>
                <Typography level="body-sm" className="mtska-metric-label">{t(label)}</Typography>
                <Typography level="h4" className="mtska-metric-value">{value}</Typography>
            </CardContent>
        </Card>
    );
};

export default MetricCard;